const n8nChatbotDictES = {
  // Interface texts
  chatTitle: "Chat Extraconomy",
  chatTitleDev: "Chat Extraconomy (Modo Dev)",
  statusOnline: "En línea",
  statusOffline: "Desconectado",
  statusChecking: "Verificando...",
  statusDevMode: "Modo Dev",
  placeholder: "Escribe tu mensaje...",
  tooltip: "¡Contáctanos!",

  // Welcome message
  welcomeMessage: "¡Hola! Soy el asistente virtual de Extraconomy. ¿Cómo puedo ayudarte hoy?",

  // Loading states
  typing: "Escribiendo...",

  // Error messages
  errorGeneric: "Lo siento, estoy teniendo dificultades técnicas en este momento. Por favor, contáctanos a: support@extraconomy.com",
  errorWithDetails: "Lo siento, estoy teniendo dificultades técnicas en este momento. Por favor, contáctanos a: support@extraconomy.com\n\nError: {error}",

  // Fallback responses
  fallbackResponse: "¡Gracias por tu mensaje! Estoy aquí para ayudar con información sobre Extraconomy. Puedes preguntar sobre registro, planes, funcionalidades o cualquier otra pregunta!"
};

export default n8nChatbotDictES;
